import { warn as vueWarn } from "vue-demi";
export function warn(msg, ...params) {
  vueWarn(`[vue-recaptcha]: ${msg}`, ...params);
}
export function invariant(condition, msg) {
  if (!condition) {
    warn(msg);
    throw new Error(`Invariant violation: ${msg}`);
  }
}
